import { createAsyncThunk } from "@reduxjs/toolkit";
import phpClient from "../../../network/phpClient";

interface Payload {
  employee_id: string;
  field_code: string;
  field_value: string;
  effective_date: string;
}

export const addPayrollFieldValueThunk = createAsyncThunk(
  "payrollField/addValue",
  async (payload: Payload, thunkAPI) => {
    try {
      const response: any = await phpClient.post({
        url: "/employees/add_payroll_field_value",
        data: payload,
      });

      if (response && response.status) {
        return response;
      }

      return thunkAPI.rejectWithValue(response?.message || "Failed to save payroll field");
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.message || "Error saving payroll field");
    }
  }
);

export const fetchPayrollFieldsThunk = createAsyncThunk(
  "payrollField/fetchFields",
  async (employee_id: string, thunkAPI) => {
    try {
      const response: any = await phpClient.post({
        url: "/employees/payroll_field",
        data: { employee_id },
      });

      if (response && response.status) return response;
      return thunkAPI.rejectWithValue(response?.message || "Failed to fetch payroll fields");
    } catch (err: any) {
      return thunkAPI.rejectWithValue(err?.message || "Error fetching payroll fields");
    }
  }
);

export default addPayrollFieldValueThunk;